import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handlePutRequest } from '../../services/PutTemplate';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { handlePostRequest } from '../../services/PostTemplate';

const OTPVerification = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const inputRefs = useRef([]);
    const { userId, mobile, corporateCode } = location.state || {};

    const validationSchema = Yup.object({
        OTP: Yup.array()
            .of(Yup.string().matches(/^[0-9]?$/, 'Each field must be a single digit.'))
            .test(
                'all-filled',
                'All fields must be filled and valid.',
                (values) => values.every((value) => /^[0-9]$/.test(value))
            ),
    });

    const formik = useFormik({
        validationSchema,
        initialValues: { OTP: ['', '', '', ''] },
        onSubmit: async ({ OTP }) => {
            const otp = OTP.join('')
            const corporteCode = " ";
            if (userId && mobile) {
                const payload = {
                    userId,
                    mobile,
                    otp: otp,
                };
                try {
                    const response = await dispatch(
                        handlePutRequest("api/user/updateMoible", payload, true, true)
                    );
                    if (response?.status) {
                        history.push("/passenger-profile");
                    }
                    return response;
                } catch (error) {
                    if (error?.decryptedData?.msg === "OTP expire!") {
                        history.push("/passenger-profile")
                    }
                }
            }

            if (corporteCode) {
                const payload = {
                    userId,
                    corporateCode,
                    otp: otp,
                };

                try {
                    const response = await dispatch(
                        handlePostRequest("api/user/addCorporateCode", payload, true, true)
                    );

                    if (response?.status) {
                        history.push("/corporate");
                    }
                    return response;
                } catch (error) {

                    if (error?.decryptedData?.msg === "OTP expire!") {
                        history.push("/corporate")
                    }
                }
            }

        },
    });

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^[0-9]$/.test(value) && value !== '') return;

        const otp = [...formik.values.OTP];
        otp[index] = value;
        formik.setFieldValue('OTP', otp);
        if (value && index < otp.length - 1) {
            // inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        const { key } = e;
        if (key === 'ArrowLeft' && index > 0) {
            // inputRefs?.current[index - 1]?.focus();
        } else if (key === 'ArrowRight' && index < inputRefs?.current?.length - 1) {
            // inputRefs?.current[index + 1]?.focus();
        } else if (key === 'Backspace') {
            const otp = [...formik.values.OTP];
            if (otp[index] === '' && index > 0) {
                // inputRefs?.current[index - 1]?.focus();
            } else {
                otp[index] = '';
                formik.setFieldValue('OTP', otp);
            }
        }
    };

    const getFormErrorMessage = () =>
        formik.errors.OTP && formik.touched.OTP && (
            <small className="p-error">{formik.errors.OTP}</small>
        );

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="flex login-main-body align-items-center justify-content-center overflow-hidden">
                <div className="login-div-border">
                    <div className="w-full surface-card py-8 px-5 sm:px-6">
                        <div className="otp-verification-container flex justify-content-center align-items-center flex-column mt-5">
                            <h2 className="otp-heading mb-3">OTP Verification</h2>
                            <p className="otp-message mb-3">We have sent an OTP to your mobile number</p>
                            <label htmlFor="otp" className="mb-2">Enter the 4-digit SMS OTP</label>
                            <div className="flex justify-content-center mb-3">
                                {formik?.values?.OTP.map((digit, index) => (
                                    <InputText
                                        key={index}
                                        value={digit}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        maxLength={1}
                                        className="otp-input mr-2"
                                        style={{ width: '40px', textAlign: 'center' }}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                    />
                                ))}
                            </div>
                            {getFormErrorMessage()}
                            <Button
                                label="Verify OTP"
                                className="p-button-primary mt-3"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default OTPVerification;
